export const ITEMS_PER_TABLE_PAGE = 10
export const SIDEBAR_COOKIE_NAME = 'sidebar_state'
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7
export const SIDEBAR_WIDTH_REM_NUMERIC = 16.5
export const SIDEBAR_WIDTH = `${SIDEBAR_WIDTH_REM_NUMERIC}rem`
export const SIDEBAR_WIDTH_MOBILE = '18rem'
export const SIDEBAR_WIDTH_ICON = '3rem'
export const SIDEBAR_KEYBOARD_SHORTCUT = 'b'

export const currencySymbols: Record<string, string> = {
  EUR: '€',
  USD: '$',
  GBP: '£',
}

/** Depanneo's astreinte line, shown when a request needs a human faster than a flow. */
export const DEPANNEO_SUPPORT_PHONE = '09 70 70 99 10'

export const PAGE_URL_PARAM = 'page'
export const ACTIONS_TABLE_ID = 'actions'
// SIREN_REGEX moved to `@depanneo/validation` as `SIREN_PATTERN` (#1488): the API
// DTOs and the CSV importer validate the same identifiers, and three copies of the
// expression is what drifted.

export const MAX_SIZE_MB = 5
export const DOCS_ACCEPTED_TYPES = ['.pdf']
export const IMAGE_ACCEPTED_TYPES = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.heic',
  '.heif',
]
export const VIDEO_ACCEPTED_TYPES = ['.mp4', '.webm', '.mov']
export const DEFAULT_ACCEPTED_TYPES = [
  ...IMAGE_ACCEPTED_TYPES,
  ...DOCS_ACCEPTED_TYPES,
]
// Default types plus video — used where uploading (and viewing) clips is wanted,
// e.g. the intervention Documents tab. Videos can be large, so callers using this
// list also allow the larger server-side size limit.
export const DOCUMENT_WITH_VIDEO_ACCEPTED_TYPES = [
  ...DEFAULT_ACCEPTED_TYPES,
  ...VIDEO_ACCEPTED_TYPES,
]

export const GMAPS_FIELDS = {
  ADDRESS_LINE1: 'addressLine1',
  ADDRESS_LINE2: 'addressLine2',
  CITY: 'city',
  POSTAL_CODE: 'postalCode',
  DEPARTMENT: 'department',
  REGION: 'region',
  COUNTRY: 'country',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
  GMAPS_PLACE_ID: 'gmapsPlaceId',
}

export const USER_FORM_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  MOBILE_PHONE: 'mobilePhone',
  LANDLINE_PHONE: 'landlinePhone',
  JOB_TITLE: 'jobTitle',
}

export const DATE_GROUP_LABELS = {
  TODAY: "Aujourd'hui",
  YESTERDAY: 'Hier',
  OLDER: 'Plus ancien',
} as const

export const AVATAR_SIZE = 32
export const AVATAR_RADIUS = AVATAR_SIZE / 2
